import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { GET } from "../../utils/fetchUtil";
import { useDebounce } from "../../common/hooks/useDebounce";
import { isTouch } from "../../utils/screenUtil";
import InputField from "../../common/input/InputField";
import { useQuery } from "../../common/hooks/useQuery";
import { useTranslation } from "react-i18next";
import Tabs from "../../common/tabs/Tabs";
import Tab from "../../common/tabs/Tab";
import Resolving from "./overview/preview/resolvingRequests/Resolving";
import Waiting from "./overview/preview/resolvingRequests/Waiting";
import Solved from "./overview/preview/resolvingRequests/Solved";
import { InfoBarContext } from "../../common/info";
import Loader from "../../common/loader/Loader";
import { smoothScroll } from "../../utils/scrollbarUtil";
import { MessageContext } from "../../common/message";
import { useHistory } from "react-router-dom";

function RequirementsInResolvingPage() {
  const [request, setRequest] = useState(undefined);
  const [response, setResponse] = useState([]);
  const [resolving, setResolving] = useState([]);
  const [waiting, setWaiting] = useState([]);
  const [solved, setSolved] = useState([]);
  const [query, setQuery] = useState("");
  const debouncedQuery = useDebounce(query, 250);
  const { t } = useTranslation();
  const [activeJournalId, setActiveJournalId] = useState(null);
  const infoBar = useContext(InfoBarContext);
  const message = useContext(MessageContext);
  const [activeTab, setActiveTab] = useState(0);
  const [tabs, setTabs] = useState([]);
  const queryParams = useQuery();
  const [readyToScroll, setReadyToScroll] = useState(false);
  const [elementScrollId, setElementScrollId] = useState();

  const history = useHistory();

  const linkTab = history.location.state?.linkTab;
  const tab = history.location.state?.tab;

  useEffect(() => {
    setElementScrollId(queryParams.get("uid"));
  }, [queryParams]);

  useLayoutEffect(() => {
    setTimeout(() => {
      smoothScroll("#recit" + elementScrollId);
    }, 0);
  }, [elementScrollId, request]);

  useEffect(() => {
    GET(
      "/requests/submissions?status=2" +
        (debouncedQuery.length > 0 ? `&query=${debouncedQuery}` : ""),
      (requests) => {
        setRequest(requests);
        setResponse(
          requests.requests
            .filter((req) => req.title.toString().toLowerCase().includes(query))
            .sort(function (dateA, dateB) {
              return new Date(dateB.submissionDate) - new Date(dateA.submissionDate);
            })
        );
        setReadyToScroll(queryParams.get("id") ? true : false);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );

    return () => setRequest([]);
  }, [debouncedQuery]);

  useLayoutEffect(() => {
    if (linkTab !== undefined) {
      setActiveTab(parseInt(linkTab));
    }
  }, [linkTab]);

  useLayoutEffect(() => {
    if (tab !== undefined) {
      setActiveTab(parseInt(tab));
    }
  }, [tab]);

  useEffect(() => {
    if (response !== undefined) {
      setResolving(
        response.filter(
          (response) => response.statusColor === "red" || response.statusColor === "danger"
        )
      );
      setWaiting(
        response.filter(
          (response) => response.statusColor === "yellow" || response.statusColor === "warning"
        )
      );
      setSolved(
        response.filter(
          (response) => response.statusColor === "green" || response.statusColor === "success"
        )
      );
    }
  }, [response]);

  useEffect(() => {
    setTabs([
      t("requests.resolvingRequests.resolving.tab") + ` (${resolving.length})`,
      t("requests.resolvingRequests.waiting.tab") + ` (${waiting.length})`,
      t("requests.resolvingRequests.solved.tab") + ` (${solved.length})`,
    ]);
  }, [resolving, waiting, solved]);

  useEffect(() => {
    if (!infoBar.isOpen) {
      setActiveJournalId(null);
    }
  }, [infoBar.isOpen, setActiveJournalId]);

  if (request) {
    return (
      <div className="ml-2 mr-2">
        <div className="mt-2 is-flex is-flex-direction-row-reverse">
          <div className="field control" style={{ width: isTouch() ? "100%" : "25%" }}>
            <InputField
              placeholder={t("requests.received.searchInputFieldPlaceholder")}
              onChange={(e) => setQuery(e.currentTarget.value)}
              value={query}
            />
          </div>
        </div>
        <Tabs setActiveTab={setActiveTab} activeTab={activeTab} scrollableContentHeight={812}>
          <Tab
            label={tabs[0]}
            render={() => (
              <Resolving
                requests={resolving}
                activeJournalId={activeJournalId}
                setActiveJournalId={setActiveJournalId}
                title={tabs[0]}
                setResolving={setResolving}
              />
            )}
          />
          <Tab
            label={tabs[1]}
            render={() => (
              <Waiting
                requests={waiting}
                activeJournalId={activeJournalId}
                setActiveJournalId={setActiveJournalId}
                title={tabs[1]}
              />
            )}
          />
          <Tab
            label={tabs[2]}
            render={() => (
              <Solved
                requests={solved}
                activeJournalId={activeJournalId}
                setActiveJournalId={setActiveJournalId}
                title={tabs[2]}
              />
            )}
          />
        </Tabs>
      </div>
    );
  } else {
    return <Loader />;
  }
}

export default RequirementsInResolvingPage;
